import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["dropzone", "input", "filename", "submit"]

  connect() {
    this.dragDepth = 0
    this.multipleFilesMessage = this.data.get("multiple-files-message")
    this.invalidFileMessage = this.data.get("invalid-file-message")
    this.fileTooLargeMessage = this.data.get("file-too-large-message")
    this.onDragEnter = event => this.dragEnter(event)
    this.onDragOver = event => this.dragOver(event)
    this.onDragLeave = event => this.dragLeave(event)
    this.onDrop = event => this.drop(event)

    this.dropzoneTarget.addEventListener("dragenter", this.onDragEnter)
    this.dropzoneTarget.addEventListener("dragover", this.onDragOver)
    this.dropzoneTarget.addEventListener("dragleave", this.onDragLeave)
    this.dropzoneTarget.addEventListener("drop", this.onDrop)
  }

  disconnect() {
    this.dropzoneTarget.removeEventListener("dragenter", this.onDragEnter)
    this.dropzoneTarget.removeEventListener("dragover", this.onDragOver)
    this.dropzoneTarget.removeEventListener("dragleave", this.onDragLeave)
    this.dropzoneTarget.removeEventListener("drop", this.onDrop)
  }

  dragEnter(event) {
    event.preventDefault()
    this.dragDepth += 1
    this.dropzoneTarget.classList.add("is-dragging")
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "copy"
  }

  dragLeave(event) {
    event.preventDefault()
    this.dragDepth -= 1

    if (this.dragDepth <= 0) this.resetDropzone()
  }

  drop(event) {
    event.preventDefault()
    this.resetDropzone()

    const files = event.dataTransfer.files
    if (files.length > 1) {
      alert(this.multipleFilesMessage)
      return
    }

    const file = files[0]
    if (!file || !this.validate(file)) return

    this.inputTarget.files = files
    this.showFilename(file)

    this.submit()
  }

  uploadSelectedFile() {
    const file = this.inputTarget.files[0]

    if (!file) {
      this.filenameTarget.textContent = ""
    } else if (this.validate(file)) {
      this.showFilename(file)
      this.submit()
    } else {
      this.inputTarget.value = ""
      this.filenameTarget.textContent = ""
    }
  }

  validate(file) {
    const jpegName = /\.jpe?g$/i.test(file.name)
    const jpegType = file.type === "image/jpeg" || file.type === ""
    const maxSize = Number(this.data.get("max-size"))

    if (!jpegName || !jpegType) {
      alert(this.invalidFileMessage)
      return false
    }

    if (file.size > maxSize) {
      alert(this.fileTooLargeMessage)
      return false
    }

    return true
  }

  showFilename(file) {
    this.filenameTarget.textContent = file.name
  }

  submit() {
    this.submitTarget.click()
  }

  resetDropzone() {
    this.dragDepth = 0
    this.dropzoneTarget.classList.remove("is-dragging")
  }
}
